<template>
    <div class="transaction-main">
        <div class="main">
            <div class="filter-box">
                <div class="fl">
                    <p class="fl label">订单编号</p>
                    <input class="fl input-box" v-model="orderNum" placeholder="请输入订单编号"/>
                    <!--<p class="fl label">订单状态</p>-->
                    <!--<select class="input-box fl" >-->
                        <!--<option value="1">待发货</option>-->
                        <!--<option value="2">已完成</option>-->
                    <!--</select>-->
                </div>
                <div class="fl">
                    <p class="fl label">下单时间</p>
                    <el-date-picker class="fl "
                                    v-model="startTime"
                                    type="date"
                                    size="small"
                                    value-format="timestamp"
                                    placeholder="选择日期">
                    </el-date-picker>
                    <p class="fl text-center">至</p>
                    <el-date-picker class="fl"
                                    v-model="endTime"
                                    type="date"
                                    size="small"
                                    value-format="timestamp"
                                    placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="fr button-box" >
                    <button class="filter-button resetting fr" @click="reset">重置</button>
                    <button class="filter-button search fr" @click="search">查询</button>
                </div>
                <div class="clear"></div>
            </div>
            <div class="main-body">
                <el-table
                        :data="tableData"
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        stripe
                        style="width: 97%"
                        class="body-table"
                        :row-style="{ height: '46px' }"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                >
                    <el-table-column prop="blanketOrderNum" label="订单编号"></el-table-column>
                    <el-table-column prop="createTime" label="下单时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime | date}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="payMethod" label="付款方式">
                        <template slot-scope="scope">
                            {{scope.row.payMethod | payType}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="订单金额">
                        <template slot-scope="scope">
                            {{scope.row.amount | price}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="payTime" label="支付时间">
                        <template slot-scope="scope">
                            {{scope.row.payTime | date}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="reciver" label="收货人"></el-table-column>
                    <el-table-column prop="mobile" label="收货电话"></el-table-column>
                    <el-table-column prop="orderStatus" label="订单状态"></el-table-column>
                    <el-table-column prop="edit" label="操作">
                        <template slot-scope="scope">
                            <a @click="toToDetail(scope.row.blanketOrderNum)" class="refund pointer">查看订单</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="main-bottom">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        class="fenye"
                        @current-change="current_change"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import {getNotshippedOrder} from '@/api/shop'
  export default {
    name: "waitDeliverGoods",
    data() {
      return {
        date: '',
        tableData: [],
        startTime: '',
        endTime: '',
        orderNum: '',
        total: 10,
        pageSize: 10, //每页的数据条数
        currentPage: 1, //默认开始页面
        istag: true,
        loading:false,
        company: ''
      };
    },
    filters:{
      payType(type){
        switch (Number(type)) {
          case 1:
            return '支付宝';
          case 2:
            return '微信';
          case 3:
            return '园区币';
          case 4:
            return '对公转账';
        }
      }
    },
    mounted(){
      this.getOrderList()
    },
    methods: {
      toToDetail(orderId) {
        this.$store.state.isTable = false;
        this.$router.push({
          path: '/orderDetail',
          query: {
            orderId: orderId
          }
        })
      },
      search() {
        this.getOrderList()
      },
      reset() {
        this.currentPage = 1;
        this.orderNum = '';
        this.startTime = '';
        this.endTime = '';
        this.getOrderList()
      },
      current_change: function (currentPage) {
        this.currentPage = currentPage;
      },
      getOrderList(){
        let postData  = {
          length: this.pageSize,
          page: this.currentPage,
          source: 0  //来源 必传 没有传 -1 1是京东 0是自营
        };
        if(this.orderNum){
          postData.orderNum = this.orderNum;
        }
        if(this.startTime){
          postData.startTime = this.startTime
        }
        if(this.endTime){
          postData.endTime = this.endTime
        }
        getNotshippedOrder(postData).then(res => {
          const {notShippedOrderList, size} = res.data;
          this.total = size;
          this.tableData = notShippedOrderList;
        })
      }
    },

  };
</script>

<style scoped lang="scss">
    @import "~@/css/order.scss";
    .pay-button{
        width: 68px;
        height: 30px;
        background:#5189F7;
        border-radius: 2px;
        color: #FFFFFF;
        font-size: 14px;
    }
    .logistics-model{
        z-index: 999;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0,0,0,0.4);
        .mask{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 100;
        }
        .logistics-box{
            z-index: 200;
            width: 478px;
            height: 248px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            opacity: 1;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            top: calc(50% - 124px);
            .title{
                color: #303030;
                font-size: 16px;
            }
            .button-box{
                margin-top: 30px;
                button{
                    cursor: pointer;
                    width: 76px;
                    height: 34px;
                    border-radius: 8px 8px 8px 8px;
                    margin: 0 20px;
                    box-sizing: border-box;
                }
                .cancel{
                    background: #FFFFFF;
                    border: 1px solid #E0E0E0;
                    color: #646464;
                }
                .confirm{
                    background: #5189F7;
                    color: #FFFFFF;
                }
            }
        }
    }
</style>
